import React, { Component } from 'react';
import { Table, Button, Alert, Spinner  } from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Card, CardHeader, CardBody, Row, Col, Collapse, Input } from 'reactstrap';
import { InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { AiOutlineSearch, AiOutlineReload } from 'react-icons/ai';
import { FaEdit, FaPlus, FaTrashAlt, FaCheckSquare } from 'react-icons/fa';
import { withRouter } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
/*import history from "../history";*/
import './NavMenu.css';
import url from "./variables/url.js";
import { AppContext } from '../AppContext';
import Paginacion from './Paginacion';
import ActividadCard from './ActividadCard';
import ReactHTMLTableToExcel from "react-html-table-to-excel";

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;
const homepage = process.env.REACT_APP_EXP;


export class ConsultarInsignias extends Component {
    static displayName = ConsultarInsignias.name;

    constructor(props) {
        super(props);
        this.state = {
            status: 0,
            numeroPersonasInsignias: 0,
            page: 1,
            buscar: '',
            buscarNombre: '',
            buscarCategoria: 1,
            buscarCantidad: 1,
            tipoBusqueda: "C",
            loading: true,            
            activeTab: 1,
            collapse: 1,
            idestudiante: 0,
            actividades: [],
            categorias: [],
            iduser: 0,
            roles: [],
            currentActividades: [], currentPage: null, totalPages: null,
            pestanias: [{ id: 1, nombre: 'Insignias conseguidas' }, { id: 2, nombre: 'Insignias a punto de conseguirse' }],
            cantidades: [{ id: 1, nombre: 'Faltando 1 criterio' }, { id: 2, nombre: 'Faltando 2 criterios' }, { id: 3, nombre: 'Faltando 3 criterios' }],
            totalPageA: 0,
            actualPage: 1,
            limite: 10,
            siblingCount: 1,
            currentPage: 1,
            currentTotalPages: 0,
            postsActividad: [],
            respItems: -1,
            postsPerPage: 10
        };

        this.toggle = this.toggle.bind(this);
        this.toggleCard = this.toggleCard.bind(this);
        this.onChangeCategoria = this.onChangeCategoria.bind(this);
        this.onChangeCantidad = this.onChangeCantidad.bind(this);
        this.searchByCategoria = this.searchByCategoria.bind(this);
        this.handleAsignar = this.handleAsignar.bind(this);
        this.actualizarActividades = this.actualizarActividades.bind(this);
        this.onChangeLimite = this.onChangeLimite.bind(this);
        if (this.props.location.state)
         this.actualizarActividades(this.props.location.state.actividad)
    }

    componentDidMount() {
        this.populateInfoData();
        this.populateActividades();        
        let currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                //console.log('Ok');
            } else {
                this.isForbidden();
            }

        }
    }

    componentDidUpdate() {
        let currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                //console.log('Ok');
            } else {
                this.isForbidden();
            }

        }
    }

    isForbidden() {
        this.props.history.push({
            pathname: homepage,
        })
    }

    setPagePrevious() {
        if (this.state.currentPage !== 1) {
            let p = this.state.currentPage;
            this.setState({
                currentPage: p - 1
            });
        }
    }

    setPageNext() {
        if (this.state.currentPage !== this.state.totalPageA) {
            let p = this.state.currentPage;
            this.setState({
                currentPage: p + 1
            });
        }
    }

    setPage = (pageNum) => {
        this.setState({ currentPage: pageNum })
    }   

    setYouAreMySibling(num) {
        let actualPage = this.state.currentPage;
        let sibling = this.state.siblingCount;
        let total = this.state.totalPageA;
        let valor = false;
        if (num === actualPage || num - sibling === actualPage || num + sibling === actualPage) {
            valor = true;
        }
        if (actualPage === 1 && (num - 1 === actualPage || num - 2 === actualPage || num - 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === 2 && (num - 1 === actualPage || num - 2 === actualPage)) {
            valor = true;
        }
        if (actualPage === total && (num + 1 === actualPage || num + 2 === actualPage || num + 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === total - 1 && (num + 1 === actualPage || num + 2 === actualPage)) {
            valor = true;
        }        
        return valor;
    }

    reLoadTotalPage(lenActividades, limite) {
        this.setState({ totalPageA: Math.ceil(lenActividades / limite), actualPage: 1, currentPage: 1 });
                
    }

    actualizarActividades(actividad) {
        let actividades = this.state.actividades;
        let indice = actividades.indexOf(actividad);
        actividades[indice] = actividad;
        this.setState({ actividades: actividades });
    }

    onChangeLimite(event) {
        //console.log('Cambio limite');
        //console.log(event.target.value);
        var num = event.target.value;
        this.setState({ limite: num });
        this.reLoadTotalPage(this.state.actividades.length, num);
    }

    miEstado(est) {
        let estado = 'En Revisi\u00F3n';
        if (est == 'A') {
            estado = 'Aprobado';
        } else if (est == 'R') {
            estado = 'Rechazado';
        } else if (est == 'D') {
            estado = 'Devuelto';
        }
        return estado;
    }

    componentWillReceiveProps(nextProps) {
        /*console.log('componentWillReceiveProps', nextProps);*/
        this.setState(nextProps);
    }

    onPageChanged = data => {
        const { actividades } = this.state;
        const { currentPage, totalPages, pageLimit } = data;
        const offset = (currentPage - 1) * pageLimit;
        const currentActividades = actividades.slice(offset, offset + pageLimit);

        this.setState({ currentPage, currentActividades, totalPages });
    }

    KeyPressEstudiante = (event) => {
        if (event.charCode === 13 && this.state.buscar !== "") {    
            this.searchById();
        }
    }

    KeyPressEstudianteNombre = (event) => {
        if (event.charCode === 13 && this.state.buscarNombre !== "") {
            this.searchByNombre();
        }
    }

    KeyPressCategoria = (event) => {
        if (event.charCode === 13 && this.state.buscarCategoria >= 1) {
            this.searchByCategoria();
        }
    }

    KeyPressTipo = (event) => {
        if (event.charCode === 13 && this.state.buscarCategoria >= 1) {
            this.searchByTipo();
        }
    }

    renderGestionTable(actividades) {
        
        const indexOfLastPost = this.state.currentPage * this.state.limite;

        const indexOfFirstPost = indexOfLastPost - this.state.limite;

        const currentPosts = actividades.slice(indexOfFirstPost, indexOfLastPost);

        const pageNumbers = []

        for (let i = 1; i <= Math.ceil(actividades.length / this.state.limite); i++) {
            pageNumbers.push(i);
        }

        return (
            <div>                
                {this.state.respItems > 0 ?
                    <>
                        <div>
                            <ReactHTMLTableToExcel
                                id="table-xls-button"
                                className="page-link"
                                table="table-to-xls"
                                filename="Data"
                                sheet="sheet1"
                                buttonText="Exportar como Excel"
                            />
                        </div>

                        <br />

                        <div className="w-full flex justify-around">
                            <Row hidden={this.state.actividades.length === 0} id={'newPagination'}>
                                <Col xs="2">
                                    <Input className="col-md-6" style={{ width: '5vw' }} type="select" onChange={this.onChangeLimite} value={this.state.limite} >
                                        <option hidden key={"sel-1"} selected={1 == this.state.limite} value={1}>{1}</option>
                                        <option key={"sel-5"} selected={5 == this.state.limite} value={5}>{5}</option>
                                        <option key={"sel-10"} selected={10 == this.state.limite} value={10}>{10}</option>
                                        <option key={"sel-25"} selected={25 == this.state.limite} value={25}>{25}</option>
                                        <option key={"sel-50"} selected={50 == this.state.limite} value={50}>{50}</option>
                                        <option key={"sel-100"} selected={100 == this.state.limite} value={100}>{100}</option>
                                    </Input>
                                </Col>
                                <Col>
                            <Pagination hidden={pageNumbers.length < 1} >
                                <PaginationItem active={this.state.currentPage === 1} onClick={() => { this.setPage(1); }}>
                                    <PaginationLink>
                                        {1}
                                    </PaginationLink>
                                </PaginationItem>
                                <PaginationItem hidden={this.state.totalPageA < 5 || this.state.currentPage === 1} onClick={() => { this.setPagePrevious(); }}>
                                    <PaginationLink previous />
                                </PaginationItem>
                                {pageNumbers.map((page, i) =>
                                (
                                    <PaginationItem key={i} hidden={i + 1 === 1 || i + 1 === this.state.totalPageA || !this.setYouAreMySibling(i + 1)} active={this.state.currentPage === i + 1} onClick={() => { this.setPage(i + 1); }}>
                                        <PaginationLink>
                                            {i + 1}
                                        </PaginationLink>
                                    </PaginationItem>)
                                )}
                                <PaginationItem hidden={this.state.totalPageA < 5 || this.state.currentPage === this.state.totalPageA} onClick={() => { this.setPageNext(); }}>
                                    <PaginationLink next />
                                </PaginationItem>
                                <PaginationItem hidden={this.state.totalPageA === 1} active={this.state.currentPage === this.state.totalPageA} onClick={() => { this.setPage(this.state.totalPageA); }}>
                                    <PaginationLink>
                                        {this.state.totalPageA}
                                    </PaginationLink>
                                </PaginationItem>
                                    </Pagination>
                                </Col>
                            </Row>
                        </div>
                        
                        <div>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Estudiante</th>
                                        <th>Matricula</th>
                                        <th>Identificaci&oacute;n</th>
                                        <th>Insignia</th>
                                        {this.state.tipoBusqueda == 'C' ? 
                                            <><th>Fecha</th>
                                            <th>Responsable</th>
                                            <th>Opciones</th></>
                                        :
                                            <><th>Resultado actual</th>
                                            <th>Total a cumplir</th>
                                            </>
                                        }
                                    </tr>
                                </thead>

                                <tbody>
                                    {currentPosts.map((act, i) => {
                                        return <tr id={i} key={i} hidden={!(this.state.actualPage === Math.ceil((i + 1) / this.state.limite))}>
                                            <td>{(i + 1 + (this.state.limite * (this.state.currentPage - 1)))}</td>
                                            {act.estudiante !== null ? <td>{act.estudiante.apellidos + ' ' + act.estudiante.nombres}</td> : <td>-</td>}
                                            {act.estudiante !== null ? <td>{act.estudiante.codestudiante}</td> : <td>-</td>}
                                            {act.estudiante !== null ? <td>{act.estudiante.numeroidentificacion}</td> : <td>-</td>}
                                            {act.insignia !== null ? <td>{act.insignia.nombre}</td> : <td>-</td>}
                                            {this.state.tipoBusqueda == 'C' ?
                                                <>{ act.fechaConsegida !== null ? <td>{act.fechaConsegida.split("T")[0]}</td> : <td>-</td> }
                                                {act.responsable != null ? <td>{act.responsable.apellidos + ' ' + act.responsable.nombres}</td> : <td>-</td>}
                                                {act.responsable == null ? <td><button className="btn btn-sm btn-success" onClick={(id) => this.handleAsignar(act.idaexresultadoinsignia)}>Asignar</button></td> : <td>-</td>}</>
                                            :
                                                <><td>{act.resultado}</td>
                                                <td>{act.totalacumplir}</td></>
                                            }
                                            
                                        </tr>
                                        }
                                    )}
                                </tbody>

                            </Table>

                            <div className="hidden-element">
                                <Table id="table-to-xls">

                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Estudiante</th>
                                            <th>Matricula</th>
                                            <th>Identificaci&oacute;n</th>
                                            <th>Insignia</th>
                                            <th>IdInsignia</th>
                                            <th>IdPersona</th>
                                            {this.state.tipoBusqueda == 'C' ?
                                                <><th>Fecha</th>
                                                    <th>Responsable</th></>
                                                :
                                                <><th>Resultado actual</th>
                                                    <th>Total a cumplir</th>
                                                </>
                                            }
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {actividades.map((act, i) => {
                                            return <tr id={i} key={i} hidden={!(this.state.actualPage === Math.ceil((i + 1) / this.state.limite))}>
                                                <td>{(i + 1 + (this.state.limite * (this.state.currentPage - 1)))}</td>
                                                {act.estudiante !== null ? <td>{act.estudiante.apellidos + ' ' + act.estudiante.nombres}</td> : <td>-</td>}
                                                {act.estudiante !== null ? <td>{act.estudiante.codestudiante}</td> : <td>-</td>}
                                                {act.estudiante !== null ? <td>{act.estudiante.numeroidentificacion}</td> : <td>-</td>}
                                                {act.insignia !== null ? <td>{act.insignia.nombre}</td> : <td>-</td>}
                                                <td>{act.insignia.idaexinsignia}</td>
                                                <td>{act.idestudiante}</td>
                                                {this.state.tipoBusqueda == 'C' ?
                                                    <>{act.fechaConsegida !== null ? <td>{act.fechaConsegida.split("T")[0]}</td> : <td>-</td>}
                                                        {act.responsable != null ? <td>{act.responsable.apellidos + ' ' + act.responsable.nombres}</td> : <td>-</td>}</>
                                                    :
                                                    <><td>{act.resultado}</td>
                                                        <td>{act.totalacumplir}</td></>
                                                }

                                            </tr>
                                        }
                                        )}
                                    </tbody>

                                </Table>
                            </div>

                        </div>
                    </>
                    : <><div /></>}
                {this.state.respItems === 0 ? < Card body className="text-center py-3">No se encontraron Resultados.</Card> : <></>}
            </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <><Spinner animation="grow" /></>
            : this.renderGestionTable(this.state.actividades);

        return (
            <div>
                <strong>Total de estudiantes que han conseguido de insignias: </strong> {this.state.numeroPersonasInsignias} <br />
                <hr />
                <Nav pills>
                    {this.state.pestanias.map((pes,i) =>
                        <NavItem key={i}>
                            <NavLink className="icon-pointer" active={pes.id === this.state.activeTab} onClick={() => { this.toggle(pes.id); }}>
                                {pes.nombre}
                            </NavLink>
                        </NavItem>
                    )}
                </Nav>
                <hr />
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={1}>
                        <Row>
                            <InputGroup className="col-md-6">
                                <Input className="form-control" type="select" onChange={this.onChangeCategoria} onKeyPress={this.KeyPressCategoria} >
                                    <option key="0" value="0">Todas</option>
                                    {this.state.categorias.map(insignia =>
                                        <option key={insignia.idaexinsignia} value={insignia.idaexinsignia}>{insignia.nombre}</option>
                                    )
                                    }
                                </Input>
                                <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => this.searchByCategoria()}>
                                        <AiOutlineSearch />
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </Row>
                        <hr />
                    </TabPane>
                    <TabPane tabId={2}>
                        <Row>
                            <InputGroup className="col-md-6">
                                <Input className="form-control" type="select" onChange={this.onChangeCantidad} >
                                    {this.state.cantidades.map(cantidades =>
                                        <option key={cantidades.id} value={cantidades.id}>{cantidades.nombre}</option>
                                    )
                                    }
                                </Input>
                                <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => this.searchByCantidad()}>
                                        <AiOutlineSearch />
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </Row>
                        <hr />
                    </TabPane>
                </TabContent>
                {contents}
            </div>
        );
    }

    populateActividades() {

        //fetch(localBack + '/api/RegistroActividad/GetWithGestion', {
        fetch(localBack + '/api/ResultadoInsignia/GetConseguidas', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status, actividades: []});
                return response.json();
            })
            .then(data => {                
                if (data.strEstado == 'S') {             
                    this.setState({ actividades: data.objDatos, loading: false, respItems: data.objDatos.length, tipoBusqueda: "C" });
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                } else {
                    this.setState({ actividades: [], loading: false, respItems: 0 });
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                }
            });
        /*this.setState({ actividades: insig.objDatos, loading: false });*/
    }

    populateInfoData() {
        fetch(localBack + '/api/Insignia', {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => response.json())
                .then(data => {                    
                    this.setState({
                        categorias: data.objDatos
                    });
                });
        fetch(localBack + '/api/Estadisticas', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                this.setState({
                    numeroPersonasInsignias: data.objDatos.estudiantesConInsignias,
                });
            });
    }


    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    toggleCard(e) {
        let event = e.target.dataset.event;
        this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) });
    }

    handleSearch = async function (event) {
        await this.setState({ buscar: event.target.value });
    }

    handleSearchNombre = async function (event) {
        //console.log(event.target.value);
        await this.setState({ buscarNombre: event.target.value });
    }

    onChangeCategoria = async function (event) {
        //console.log('Cambio Categoria');
        //console.log(event.target.value);
        var id = event.target.value;
        await this.setState({ buscarCategoria: id });
    }

    onChangeCantidad = async function (event) {
        //console.log('Cambio Categoria');
        //console.log(event.target.value);
        var id = event.target.value;
        //alert(id);
        await this.setState({ buscarCantidad: id });
    }


    onChangeTipo = async function (e) {
        //console.log('Cambio Tipo');
        //console.log(e.target.value);
        var id = e.target.value;
        await this.setState({ buscarTipo: id });
    }

    onChangeEstado = async function (e) {
        //console.log('Cambio Tipo');
        //console.log(e.target.value);
        var siglaEstado = e.target.value;
        //console.log(id);
        await this.setState({ buscarEstado: siglaEstado });
    }


    searchByCategoria() {
        this.setState({ loading: true });

        if (this.state.buscarCategoria == 0) {
            fetch(localBack + '/api/ResultadoInsignia/GetConseguidas', {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => {
                    this.setState({ status: response.status, actividades: [] });
                    return response.json();
                })
                .then(data => {
                    //console.log(data.strMensaje);
                    if (data.strEstado == 'S') {
                        this.setState({ actividades: data.objDatos, loading: false, respItems: data.objDatos.length, tipoBusqueda: "C"});
                        this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                    } else {
                        this.setState({ actividades: [], loading: false, respItems: 0 });
                        this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                    }
                });
        }
        else {
            fetch(localBack + '/api/ResultadoInsignia/GetbyInsignia/' + this.state.buscarCategoria, {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => {
                    this.setState({ status: response.status, actividades: [] });
                    return response.json();
                })
                .then(data => {
                    //console.log(data.strMensaje);
                    if (data.strEstado == 'S') {
                        this.setState({ actividades: data.objDatos, loading: false, respItems: data.objDatos.length, tipoBusqueda: "C" });
                        this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                    } else {
                        this.setState({ actividades: [], loading: false, respItems: 0 });
                        this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                    }
                });
        }
    }

    searchByCantidad() {
        this.setState({ loading: true });

        fetch(localBack + '/api/ResultadoInsignia/GetByCantidadFaltante/' + this.state.buscarCantidad, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status, actividades: [] });
                return response.json();
            })
            .then(data => {
                //console.log(data.strMensaje);
                if (data.strEstado == 'S') {
                    this.setState({ actividades: data.objDatos, loading: false, respItems: data.objDatos.length, tipoBusqueda: "F" });
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                } else {
                    this.setState({ actividades: [], loading: false, respItems: 0 });
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                }
            });
        
    }

    onlyNumber = (event) => {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    };

    handleAsignar(id) {
        //Swal.fire({
        //    title: "Cargando...",
        //    html: "Por favor, espere",
        //    timerProgressBar: true,
        //    button: false,
        //    closeOnClickOutside: false,
        //    showConfirmButton: false,
        //    closeOnEsc: false,
        //    allowOutsideClick: false
        //});
        //Swal.showLoading();

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: null
        };
        fetch(localBack + '/api/ResultadoInsignia/ActualizarResponsable/' + id + '/' + this.state.iduser, requestOptions)
            .then(response => response.json())
            .then(function (data) {
                //alert("hola");
                window.location.reload();
             }
        );
    }

}
ConsultarInsignias.contextType = AppContext;
export default withRouter(ConsultarInsignias);